import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GroupedCountryList, CountryList } from '../GroupedCountryList';
import { MigrationData } from '../MigrationData';

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss']
})
export class CountryListComponent implements OnInit {

  constructor() { }

  @Input() countryList: CountryList;
  @Input() test: MigrationData;
  @Output() selectionChanged: EventEmitter<CountryList>;

  shout(event) {
    console.log(this.test);
  }

  ngOnInit() {
    console.log(this.test);
  }


}



// WEBPACK FOOTER //
// D:/Workspace/hyblab-migration/src/app/country-list/country-list.component.ts